import { Link, Navigate } from "react-router-dom";
import { Nudge } from "../../../Types/Nudge";
import { Card, Container, Row } from "reactstrap";
import './nudge.css';

// type NudgeNavProps = ;

const RenderNudgeItem = ({ item }: { item: Nudge }) => {
    const sentDate = new Date(item?.sent).toLocaleDateString('en-us');

    return (
            <Link 
                to={`/Nudges/${item?.crmTransactionId}`} 
                state={{ item }}
                style={{ textDecoration: 'none'}}
            >
                <Card
                    // style={{ flex: 1, justifyContent: 'space-around' }}
                    key={item.crmTransactionId}
                    className='text-start p-4'
                >
                    <div style={{ display: 'inline-block' }}>
                        {item?.crmClosed ? <div className="circle-dot bg-success"></div> : <div className="circle-dot bg-warning"></div>}
                        <span style={{ fontWeight: 'bold', paddingInlineStart: 5 }}>{!item.crmClosed ? 'Open' : 'Closed'}</span>
                    </div>
                    <div style={{ display: 'inline-block' }}>
                        <span style={{ fontWeight: 'bold' }}>Cust:</span>
                        <span style={{ paddingLeft: 5 }}>{item.customerId} - {item.customerName}</span>
                    </div>
                    <div style={{ paddingBlock: 10 }}>
                        {item?.message && <span>{item.message}</span>}
                    </div>
                    <div style={{ display: 'inline-block' }}>
                        <span style={{ fontWeight: 'bold' }}>Sent Date:</span>
                        <span style={{ paddingLeft: 5 }}>{sentDate}</span>
                    </div>
                </Card>
            </Link>
    )
};

export default RenderNudgeItem;